<mat-toolbar class="toolbar" color="accent">
    <a class="home-link" routerLink="/">
        <img id="logo" src="/assets/img/logo.png">
        <span>{{ 'MAIN.TITLE' | translate }}</span>
    </a>
    <span class="spacer"></span>
    <div class="user-desk">
        <button [matMenuTriggerFor]="menu" class="open-menu" mat-button aria-label="icon-button with username and dropdown-menu">
          <div class="avatar user">
            <app-avatar [width]="50" [height]="50"></app-avatar>
          </div>

          <ng-container *ngIf="user.first_name || user.last_name, else email">
              <span class="user set-margin">{{ user.first_name }} {{ user.last_name }}</span>
          </ng-container>
          <ng-template #email>
            <span *ngIf="user.email, else emptyValue" class="user">{{ user.email }}</span>
          </ng-template >
            <mat-icon class="user">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
            <a mat-menu-item routerLink="/setting">
                <mat-icon>account_circle</mat-icon>
                <span>{{ 'PAGE.PROFILE' | translate }}</span>
            </a>
            <button mat-menu-item (click)="logout()">
                <mat-icon>logout</mat-icon>
                <span>{{ 'PAGE.LOGOUT' | translate }}</span>
            </button>
        </mat-menu>
    </div>
    <button mat-icon-button class="menu-mobile" aria-label="icon-button with menu icon" (click)="sidenav.toggle()">
        <mat-icon>menu</mat-icon>
    </button>
</mat-toolbar>
<ng-template #emptyValue>
  <p>{{'LABEL.EMPTY'  | translate}}</p>
</ng-template>
